// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/SearchResults/SearchResultsCustomer/SearchResultsCustomer.css
// module id = 1427
// module chunks = 0